export default "__VITE_ASSET__565bbaa0__"